import React from 'react';
import Title from 'src/components/AccountSettings/Title';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';

interface Props {
  collegeListingId: string;
}

const columns: ColumnSettings[] = [
  {
    name: 'firstName',
    title: 'First Name',
    editable: true,
    sortable: true,
  },
  {
    name: 'major',
    title: 'Major',
    editable: true,
    sortable: true,
  },
  {
    name: 'year',
    title: 'Year',
    editable: true,
    sortable: true,
  },
  {
    name: 'body',
    title: 'Body',
    editable: true,
    sortable: false,
  },
];

const ManageTestimonials = ({collegeListingId}: Props) => (
  <div data-testid="manage-testimonials">
    <Title>Testimonials</Title>
    <EditableTable
      basePath={`/v1/admin/college-testimonials?college_listing_id=${collegeListingId}`}
      defaultSortKey="firstName"
      columns={columns}
      identifier="college-testimonials"
      defaultValues={{collegeId: collegeListingId, collegeListingId: collegeListingId}}
    />
  </div>
);

export default ManageTestimonials;
